import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { QuestionnaireHandlerKey } from "../../context/QuestionnaireContext";
import { QuestionnaireWarningAlert } from "./QuestionnaireWarningAlert";

interface QuestionnaireConfirmDialogProps {
  handlerKey: QuestionnaireHandlerKey | null;
  warningDescription?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const QuestionnaireConfirmDialog = ({
  handlerKey,
  warningDescription,
  onConfirm,
  onCancel,
}: QuestionnaireConfirmDialogProps) => {
  const { t } = useTranslation();

  if (!handlerKey) return null;

  return (
    <AlertDialog open={!!handlerKey} onOpenChange={onCancel}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t(`questionnaires.dialogs.${handlerKey}.title`)}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t(`questionnaires.dialogs.${handlerKey}.description`)}
          </AlertDialogDescription>
        </AlertDialogHeader>
        {warningDescription && (
          <div className="mt-4">
            <QuestionnaireWarningAlert message={warningDescription} />
          </div>
        )}
        <AlertDialogFooter>
          <AlertDialogCancel>{t("common.cancel")}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {t(`questionnaires.dialogs.${handlerKey}.confirm`)}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
